import React from 'react';
import { translate } from "react-translate";

import {
    Container,
    Segment,
    Menu,
	Image,
    Dropdown,
    Header,
    List,
    Grid,
    Search,
    Advertisement,
    Icon,
    Divider,
    Table,
    Input,
    TextArea,
    Item,
    Pagination,
    Modal,
    Popup,
    Label,
    Button,
} from 'semantic-ui-react';

import _ from 'lodash';
import { Link } from 'react-router-dom'

import Autosuggest from 'react-autosuggest';
import { connect } from 'react-redux';
import { addIdArticle, addModal } from '../../../redux/actions/AppAction'
import { addArticle } from '../../../redux/actions/ListAction'
import { addModalExport } from '../../../redux/actions/ConfigFileAction';

import AddListArticle from './AddListArticle'

import ListesNew from '../../../assets/svg/ListesNew.svg';
import exportList from '../../../assets/icons/exportList.png';
import plus from '../../../assets/img/plus.png';
import moin from '../../../assets/img/moin.png';
import renommer from '../../../assets/svg/renommer.svg';
import defaut from '../../../assets/default/default.png'
import warning from '../../../assets/icons/warning.png';
import exporterWhite from '../../../assets/img/exporter_white_17x18.png';
import searchDatabaseIcon from '../../../assets/img/search-database-icon.png';

import DeleteListArticle from './DeleteListArticle';
import UpdateListArticle from './UpdateListArticle';
import ModalExport from './ModalExport';

import './ListesDetailsComponent.css';
import './btn_list.css';

import { Currencies } from '../../../constants/Currencies';

import API from '../../../services/api';

const mapStateToProps = state => ({
    app: state.app,
    list: state.list
});

const mapActionToProps = {
    addIdArticle: addIdArticle,
    addArticle: addArticle,
    addModalExport : addModalExport,
}

class ConnectedListesDetailsComponent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            value: '',
            results: [],
            apiResult: [],
            fkuidlist: this.props.match.params.id,
            isLoadingFilter: false,
            filterValue: '',
            filterResults: [],
            filterResponse: [],
            filterShowResults: [],
            currency: null,
            quantities : {},
            states : {},
            titles : {},
            prices : {},
            quantityProject: 0,
            amountProject: 0,
            articlesAmount: 0
        }

        this.onSelect = this.onSelect.bind(this)
        this.changeQuantity = this.changeQuantity.bind(this)
        this.changeState = this.changeState.bind(this)
        this.changePrice = this.changePrice.bind(this)
        this.handleSearchChange = this.handleSearchChange.bind(this)
        this.handleFilterChange = this.handleFilterChange.bind(this)
        this.handleFilterSelect = this.handleFilterSelect.bind(this)
        this.handleExport = this.handleExport.bind(this);
        this.updateProjectEstimates = this.updateProjectEstimates.bind(this);
        this.updateQuantity = this.updateQuantity.bind(this);
    }

    componentWillMount() {
        var self = this;

        var listArticleData = {
            fkuidlist : this.state.fkuidlist
        }

        API.getArticleList(this.props.app.token, listArticleData).then((res) => {
            var response = res.data;
            self.props.addArticle(response.articles);

            self.props.list.list= response.list
			// set filter models
            let source = self.convertToFilterModel(response.articles)

            // Building state
            var quantities = {};
            var states = {};
            var titles = {};
            var prices = {};
            Object.entries(this.props.list.article || [] ).map((key, mainindex) => {
               quantities[mainindex] = key[1].quantity;
               states[mainindex] = key[1].state;
               titles[mainindex] = key[1].name_manually || key[1].name || '';
               prices[mainindex] = key[1].price;
            });
            self.setState({
                filterResponse: response.articles,
                filterShowResults: response.articles,
                filterSource: source,
                quantities: quantities,
                states : states,
                titles: titles,
                prices: prices
            })
            // Updating totals (article amount, articles quantity, total price)
            self.updateProjectEstimates();
        });

        API.getUser(this.props.app.token).then((res) => {
            let tmpResponseCurrencies = Currencies.filter(currency => currency.value == res.data.currency);
            self.setState({
                currency: tmpResponseCurrencies.length > 0 ? tmpResponseCurrencies[0].text : '€',
            })
        });

    }

    // Convert filter model from API result
    convertToFilterModel(response) {
        const { t } = this.props;
        let source = []
        Object.entries(response || []).map((key, mainindex) => {
            if (key[0] !== 'code' && key[0] !== 'msg') {
                let sourceValue = {
                    title: this.makeTitle(key[1].name_manually || ''),
                    //description: key[1].fkuidgrouparticle, don't have to be displayed for groupArticle
                    image: API.resourceURL + '/' + key[1].link_picture,
                    price: key[1].price + ' ' + this.state.currency,
                    response_key: key[0],
                }
                source.push(sourceValue);
            }
        })

        return source;
    }

    // make two lines or truncat
    makeTitle(title) {
        const maxLength = 50
        const oneLineLength = 26
        let truncatedTitle = title || '';
        if (title.length >= maxLength) {
            truncatedTitle = title.substring(0, maxLength) + '...'
        } else if (title.length <= oneLineLength) {
            truncatedTitle = title + ' '.repeat(maxLength - title.length) + '...'
        }
        return truncatedTitle
    }

    getGroupArticle(value) {
        const { t } = this.props;
        var self = this;
        var groupArticleData = {
            q: this.state.value,
            lang: this.props.app.lang,
            sort : "DESC",
            rang: "10"
        };
        API.getGroupArticle(this.props.app.token, groupArticleData).then((res) => {
            let searchResults = []
            if (res.data.code !== 200) {
                self.setState({
                    isLoading: false,
                    results: []
                })
                return;
            }

            for (let article of res.data.groupArticles) {
                searchResults.push({
                    //"description": article.pkuidga, don't have to be displayed for groupArticle
                    "title": self.makeTitle(article.name),
                    "price": article.spmoy + ' ' + this.state.currency,
                    "image": article.image !== 'upload/grouparticle/' ? API.resourceURL + '/' + article.image : defaut,
                    "pkuidga": article.pkuidga
                });
            }
            // const re = new RegExp(_.escapeRegExp(this.state.value), 'i')
            // const isMatch = result => re.test(result.title)
            self.setState({
                isLoading: false,
                results: searchResults,
            })
        });
    }

    resetComponent() {
        this.setState({
            isLoading: false,
            results: [],
            value: '',
            isLoadingFilter: false,
            filterValue: '',
            filterResults: [],
            filterShowResults: this.state.filterResponse
        })
    }

    handleResultSelect(e, { result }) {
        this.setState({
            value: result.title
        })
    }

    handleSearchChange(e, { value }) {
        this.setState({
            isLoading: true, value
        })

        setTimeout(() => {
            if (this.state.value.length < 1) return this.resetComponent()
            this.getGroupArticle(value);
        }, 500)
    }

    onSelect(e, data) {
        e.preventDefault();

        let isAlreadyPresentInList = false;
        let articleQuantity = 1, articleID = 1;
        Object.entries(this.props.list.article || []).map((key, mainindex) => {
            if (key[0] === 'code' || key[0] === 'msg') {
            }
            else {
                if (key[1].fkuidgrouparticle == data.result.pkuidga) {
                    isAlreadyPresentInList = true;
                    articleQuantity = key[1].quantity;
                    articleID = key[1].id;
                }
            }
        })

        if (isAlreadyPresentInList) {
            var form = new FormData();
            form.append("fkuidlist", this.state.fkuidlist);
            form.append("id", articleID);
            form.append("quantity", articleQuantity + 1);

            API.updateArticleList(this.props.app.token, form).then((res) => {
            });

        } else {
            let image = data.result.image.split("/");
            image.splice(0, 1)
            image.splice(0, 1)
            image.splice(0, 1)
            image = image.join('/')

            let price = data.result.price.replace(/[^\d+\.,]+/, '');
            price = price.replace(/,/, '.');
            if ((price.match(/./g) || []).length > 1) {
                let arr = price.split(".");
                price = arr.splice(0,2).join('.') + arr.join('');
            }
            if (price == '') {
                price = 0;
            }

            var groupArticleData = {
                fkuidlist : this.state.fkuidlist,
                fkuidgrouparticle: data.result.pkuidga,
                quantity: "1",
                price: price,
                state : "1",
                lang: this.props.app.lang,
            }
            API.createGroupArticle(this.props.app.token, groupArticleData).then((res) => {
                this.componentWillMount();
            })
        }

        this.setState({
            value: '',
        })
    }

    handleFilterSelect(e, { result }) {
        let filterShowResults = {}
        filterShowResults[result.response_key] = this.state.filterShowResults[result.response_key]
        this.props.addArticle(filterShowResults);

        this.setState({
            filterValue: result.title,
            filterShowResults: filterShowResults
        })
    }

    handleFilterChange(e, { value }) {
        this.setState({
            isLoadingFilter: true,
            filterValue: value
        })

        setTimeout(() => {
            if (this.state.filterValue.length < 1) {
                this.props.addArticle(this.state.filterResponse)
                this.resetComponent()
                return
            }

						const re = new RegExp(_.escapeRegExp(this.state.filterValue), 'i')
            const isMatch = result => re.test(result.title)
            let filterResults = _.filter(this.state.filterSource, isMatch)
            let filterShowResults = {}

						for (let i = 0; i < filterResults.length; i++) {
                filterShowResults[filterResults[i].response_key] = this.state.filterResponse[filterResults[i].response_key]
            }

						this.props.addArticle(filterShowResults)

            this.setState({
                isLoadingFilter: false,
                filterResults: filterResults,
                filterShowResults: filterShowResults
            })
        }, 500)
    }

    updateProjectEstimates() {
        let quantityProjet = 0
        let amountProjet = 0
        let articlesAmount = 0

        Object.entries(this.props.list.article || []).map((key, mainindex) => {
            if (key[0] === 'code' || key[0] === 'msg') {
            } else {
                if (this.state.states[mainindex]) {
                    articlesAmount ++;
                    quantityProjet += this.state.quantities[mainindex];
                    amountProjet += (this.state.quantities[mainindex] * this.state.prices[mainindex]);
                }
            }
        })

        this.setState({
            quantityProject : quantityProjet,
            amountProject : amountProjet,
            articlesAmount : articlesAmount
        })
    }

    changeQuantity(e, add, idarticle, quantity, mainindex) {
        var form = new FormData();
        form.append("fkuidlist", this.state.fkuidlist);
        form.append("id", idarticle);
        let sendCheck = true;
        var finalQuantity = 0;
        if (add) {
            finalQuantity = Number(quantity) + 1;
            form.append("quantity", finalQuantity);
        } else {
            if (quantity >= 1) {
                finalQuantity = Number(quantity) -1;
                form.append("quantity", finalQuantity);
            } else {
                sendCheck = false
            }
        }

        var quantitiesCopy = this.state.quantities;
        quantitiesCopy[mainindex] = finalQuantity
        this.setState({
            quantities: quantitiesCopy
        });
        this.updateProjectEstimates();

        API.updateArticleList(this.props.app.token, form).then((res) => {
        })

    }

    updateQuantity(e, mainindex, idarticle) {
        let quantity = e.target.value;
        // Forbidding bad chars
        quantity = quantity.replace(/[#$_/*-+]/g,'');
        let value = quantity.replace(/[^\d+\.,]+/, '');
        value = value.replace(/,/, '.');
        if ((value.match(/./g) || []).length > 1) {
            let arr = value.split(".");
            value = arr.splice(0,2).join('.') + arr.join('');
        }
        if (value == '') {
            value = 0;
        }

        var quantitiesCopy = this.state.quantities;
        quantitiesCopy[mainindex] = value;
        this.setState({
            quantities: quantitiesCopy
        });
        this.updateProjectEstimates();

        var form = new FormData();
        form.append("fkuidlist", this.state.fkuidlist);
        form.append("id", idarticle);
        form.append("quantity", value);
        API.updateArticleList(this.props.app.token, form).then((res) => {

        })

    }

    changeState(e, idarticle, state, mainindex) {
        e.preventDefault();
        var self = this;
        var form = new FormData();
        form.append("fkuidlist", this.state.fkuidlist);
        form.append("id", idarticle);
        var stateNb = state ? 0 : 1;
        form.append("state",  stateNb);

        API.updateArticleList(this.props.app.token, form).then((res) => {
            var statesCopy = self.state.states;
            statesCopy[mainindex] = !state
            self.setState({
                states: statesCopy
            });
            self.updateProjectEstimates();
        })


    }

    changePrice(e, data, idarticle, mainindex) {

        var form = new FormData();
        form.append("fkuidlist", this.state.fkuidlist);
        form.append("id", idarticle);

        let value = data.value.replace(/[^\d+\.,]+/, '');
        value = value.replace(/[#$_/*-+]/g,'');
        value = value.replace(/,/, '.');
        if ((value.match(/./g) || []).length > 1) {
            let arr = value.split(".");
            value = arr.splice(0,2).join('.') + arr.join('');
        }
        if (value == '') {
            value = 0;
        }

        form.append("price", value);

        API.updateArticleList(this.props.app.token, form).then((res) => {
        });

        var pricesCopy = this.state.prices;
        pricesCopy[mainindex] = value;
        this.setState({
            prices: pricesCopy
        });
        this.updateProjectEstimates();

    }

    changeTitle(e, data, idarticle, mainindex) {

        var form = new FormData();
        form.append("fkuidlist", this.state.fkuidlist);
        form.append("id", idarticle);

        let value = data.value

        form.append("title", value);

        API.updateArticleList(this.props.app.token, form).then((res) => {
        });

        var titlesCopy = this.state.titles;
        titlesCopy[mainindex] = value;
        this.setState({
            titles: titlesCopy
        });

    }

    makePathTag(path = []) {
        var parentsTag = path[0];
        for (var i = 1; i < path.length - 1; i++) {
            parentsTag = parentsTag + " / " + path[i];
        }

        return (
            <Label className='list-details-topbar-path'>
                <a id="menuTextTopRight" onClick={this.props.prevPathCallback}
                    className="list-details-topbar-path-previous-link">
                    {parentsTag + " / "}
                </a>

                <span className="list-details-topbar-path-current">
                    {path[path.length - 1]}
                </span>
            </Label>
        )
    }

    handleExport() {
       this.props.addModalExport(true);
    }

    render() {
        const { t } = this.props
        const { suggestions } = this.state;

        return (
            <div style={{ height: '100%' }}>
                <Grid stackable id="myLists">
                    <Grid.Row columns={2} id="headerSection">

                        <Grid.Column textAlign='left' width={16}>
                            <Segment basic onClick={this.handleClickReset}>
                                <Item.Image size='mini' src={ListesNew} />
                                <Item.Content verticalAlign='middle'>
                                    <Item.Header as='h3' id="titleSection">{t("Header1_title")}</Item.Header>
                                </Item.Content>
                            </Segment>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row style={{ backgroundColor: 'rgb(85, 96, 128)' }} width={16}>
                        <Grid.Column>
                            <Item.Header className="list-details-topbar-path">
                                <Link to='/lists' className="list-details-topbar-path-previous-link">
                                  {t("Header1_title")}
                                </Link>
                                {" / "}
                                <span className="list-details-topbar-path-current">
                                    {this.props.list.list ? this.props.list.list.name : ''}
                                </span>
                            </Item.Header>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row className='list_details_search_bar_container_row' >
                        <Segment.Group horizontal className='list_details_search_bar_container_segmentgroup'>
                            <Segment className='list_details_search_edit_container'>

                                <Search
                                    icon={<Image src={searchDatabaseIcon} id="searchDatabaseIcon"/> }
                                    iconPosition='left'
                                    placeholder=  {t('search_the_database')}
                                    input={{ fluid: 'true' }}
                                    loading={this.state.isLoading}
                                    onSearchChange={_.debounce(this.handleSearchChange, 500, { leading: true })}
                                    onResultSelect={this.onSelect}
                                    results={this.state.results}
                                    noResultsMessage={t("not_found")}
                                    value={this.state.value}
                                    {...this.props}
                                    id="inputSearch"
                                  className={this.state.isLoading ? 'list_details_filter_edit' : null}
                                />
                            </Segment>
                            <Segment textAlign='right' className='list_details_button_container'>
                                <AddListArticle fkuidlist={this.state.fkuidlist} />
                            </Segment>
                            <Segment textAlign='right' className='list_details_button_container'>
                               <ModalExport {...this.props} />
                               <Button
                                    circular
                                    onClick={this.handleExport}
                                    size='small'
                                    floated='right'
                                    src={exporterWhite}
                                    id="smallBtn">
                                    <Icon name='share alternate'/> {t('exporter_the_list')}
                              </Button>
                            </Segment>
                        </Segment.Group>
                    </Grid.Row>
                    <Grid.Row className='list_details_filter_bar_container_row' >
                        <Segment.Group horizontal className='list_details_filter_bar_container'>
                            <Segment className='list_details_filter_edit_container'>
                                <Search
                                    placeholder={t('filter_on_the_list')}
                                    input={{ fluid: 'true', id: 'list_details_filter' }}
                                    loading={this.state.isLoadingFilter}
                                    onSearchChange={_.debounce(this.handleFilterChange, 500, { leading: true })}
                                    onResultSelect={this.handleFilterSelect}
                                    results={this.state.filterResults}
                                    noResultsMessage={t("not_found")}
                                    value={this.state.filterValue}
                                    className={this.state.filterResults.length >= 1 ? 'list_details_filter_edit' : ''}
                                    {...this.props}
                                />
                            </Segment>
                        </Segment.Group>
                    </Grid.Row>
                </Grid>
                <Grid stackable>
                    <Grid.Row id="summaryListDetails">
                        <Grid.Column verticalAlign='bottom' className='estimate-container-column'>
                            <Container className='estimate-container' fluid>
                                <Label basic className='estimate-title'>
                                    <Image src={warning} verticalAlign='bottom' size={"tiny"} className="waring-image" />
                                    {t("title1")}
                                </Label>
                                <Label circular className='estimate-cost'>
                                    {
                                        Number((this.state.amountProject).toFixed(2))
                                    }
                                    {' ' + this.state.currency}
                                </Label>
                                <Label basic className='estimate-aticle-quantite'>
                                    <span className='estimate-text'>
                                        {this.state.articlesAmount}
                                    </span>
                                    {' ' + t("nb_article")}
                                    {t("nb_quantite") + ' '}
                                    <span className='estimate-text'>
                                        {this.state.quantityProject}
                                    </span>
                                </Label>
                            </Container>
                        </Grid.Column>

                    </Grid.Row>

                    <Divider horizontal className='estimate-divider' />

                    <Grid.Row columns={4} style={{ marginBottom: '10px' }}>
                        <Grid.Column width={7} className='details-table-header-title'>
                            {t("HeaderCell1_title")}
                        </Grid.Column>
                        <Grid.Column verticalAlign='middle' width={1} >
                        </Grid.Column>
                        <Grid.Column width={1} className='details-table-header-title' textAlign="center">
                            {t("HeaderCell2_title")}
                        </Grid.Column>
                        <Grid.Column width={3} className='details-table-header-title' textAlign="center">
                            {t("HeaderCell3_title")}
                        </Grid.Column>
                        <Grid.Column width={3} className='details-table-header-title' textAlign="center">
                            {t("HeaderCell4_title")}
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <div>
                    {
                        Object.entries(this.props.list.article || []).map((key, mainindex) => {
                            if (key[0] === 'code' || key[0] === 'msg') {
                            }
                            else {
																return (
                                    <div key={mainindex}>
                                        <Segment raised style={{ borderRadius: '10px', marginBottom: '20px' }}>
                                            <Grid>
                                                <Grid.Row columns={10}>
                                                    <Grid.Column textAlign='center' verticalAlign='middle' mobile={4} tablet={2} computer={2} className="detail-table-item">
                                                        {
                                                            key[1].link_picture === "default" || key[1].link_picture === '' || key[1].link_picture === 'upload/grouparticle/' ? (
                                                                <Image size='tiny' src={defaut} />
                                                            ) : (
                                                                    <Image size='tiny' src={API.resourceURL + '/' + key[1].link_picture} />
                                                                )
                                                        }
                                                    </Grid.Column>
                                                    <Grid.Column verticalAlign='middle' mobile={14} tablet={6} computer={6} className="detail-table-item">
                                                        <Segment.Group horizontal id="goods-name-input-wrapper-segment">
                                                            {/*<Input
                                                                transparent
                                                                type='text'
                                                                value={key[1].name_manually}
                                                                onChange={(e, data) => { this.changeTitle(e, data, key[1].id) }}
                                                              >
                                                            </Input>*/}

                                                            <TextArea
                                                            transparent
                                                            type='text'
                                                            rows={1+((key[1].name_manually || '').match(/\n/g) || []).length}
                                                            defaultValue = {key[1].name_manually || ''}
                                                            value={this.state.titles[mainindex]}
                                                            onChange={(e, data) => { this.changeTitle(e, data, key[1].id, mainindex) }}
                                                             />

                                                        </Segment.Group>
                                                    </Grid.Column>
                                                    <Grid.Column verticalAlign='middle' mobile={2} tablet={1} computer={1} className="detail-table-item">
                                                        <label className="custom-checkbox-container">
                                                            <input type="checkbox" checked={this.state.states[mainindex]} id="checkbox"
                                                                onChange={(e) => this.changeState(e, key[1].id, this.state.states[mainindex], mainindex)} />
                                                            <span className="custom-checkbox-checkmark"></span>
                                                        </label>
                                                    </Grid.Column>
                                                    <Grid.Column mobile={8} tablet={3} computer={3} textAlign='center' verticalAlign='middle'>
                                                        <Segment.Group horizontal className='price-input-wrapper-segment'>
                                                            <Input
                                                                transparent
                                                                type='text'
                                                                defaultValue={Number((key[1].price))}
                                                                value= {this.state.prices[mainindex]}
                                                                onChange={(e, data) => { this.changePrice(e, data, key[1].id, mainindex) }}
                                                                className='price-input-wrapper'>
                                                                <input
                                                                    id={'list_details_price_' + mainindex} className='list_details_price_input'
                                                                />

                                                            </Input>
                                                            <Label className='price-input-label'>{this.state.currency}</Label>
                                                        </Segment.Group>
                                                    </Grid.Column>
                                                    <Grid.Column verticalAlign='middle' mobile={2} tablet={1} computer={1} onClick={(e) => { this.changeQuantity(e, false, key[1].id, this.state.quantities[mainindex], mainindex) }}>
                                                        <Image verticalAlign='middle' src={moin} className="quantityImage"/>
                                                    </Grid.Column>
                                                    <Grid.Column verticalAlign='middle' mobile={2} tablet={1} computer={1} textAlign='center' className='amount-wrapper'>
                                                        <Segment.Group horizontal className='quantity-input-wrapper-segment'>
                                                            <Input
                                                                transparent
                                                                defaultValue={key[1].quantity}
                                                                value= {this.state.quantities[mainindex]}
                                                                onChange={(e,data) => { this.updateQuantity(e, mainindex, key[1].id)}}
                                                                className='amount'>
                                                                <input
                                                                    id={'list_details_quantity_' + mainindex} className='list_details_quantity_input'
                                                                />
                                                            </Input>
                                                        </Segment.Group>
                                                    </Grid.Column>
                                                    <Grid.Column verticalAlign='middle' mobile={2} tablet={1} computer={1} onClick={(e) => { this.changeQuantity(e, true, key[1].id, this.state.quantities[mainindex], mainindex) }}>
                                                        <Image verticalAlign='middle' src={plus} className="quantityImage"/>
                                                    </Grid.Column>
                                                    <Grid.Column verticalAlign='middle' mobile={2} tablet={1} computer={1}>
                                                        <DeleteListArticle fkuidarticle={key[1].id} fkuidlist={this.state.fkuidlist} />
                                                    </Grid.Column>
                                                </Grid.Row>
                                            </Grid>
                                        </Segment>
                                    </div>
                                )
                            }
                        })
                    }
                </div>
            </div>
        );
    }
}

const ListesDetailsComponent = connect(mapStateToProps, mapActionToProps)(ConnectedListesDetailsComponent);
export default translate("ListesDetailsComponent")(ListesDetailsComponent);



// WEBPACK FOOTER //
// ./src/components/Protected/Listes/ListesDetailsComponent.js